import React from "react";
import { useRailsDynamicFormListContext } from "../utils/rails_dynamic_form_list";
import SearchableMultiSelect, { SearchableMultiSelectProps } from "./SearchableMultiSelect";

/** 案件編集ページの「提供先企業」入力フォーム部品 */
function InquiryClientCorporationSelect(props: SearchableMultiSelectProps) {
  /**  */
  const { rows, options } = props;

  /** 動的なフォーム部品の追加や削除などを管理する仕組み 親子コンポーネントで共有 */
  const context = useRailsDynamicFormListContext({ firstRows: rows });

  /** SearchableMultiSelectコンポーネント用Props */
  const newProps: SearchableMultiSelectProps = {
    ...props,
    context
  };

  /** 現在リストアップされている提供先企業 */
  const activeClientCorporations = context.records.filter(record => !record._destroy && !!record.value);

  /** CONNPATH用ログイン権限ありの企業ID 
   ** 提供先企業が複数選択されている場合はCONPATHログイン権限付与を不可にする 
  */
  const singleSelectedClientCorporationId = String(activeClientCorporations.length == 1 ? activeClientCorporations[0].value : '');

  const singleSelectedClientCorporationLabel = singleSelectedClientCorporationId ? options.find(option => option.value == singleSelectedClientCorporationId)?.label : ''

  /** メッセージ */
  const message = (() => {
    if (singleSelectedClientCorporationId) {
      return <>
        <p>💡主にCONNPATHの閲覧権限付与やB2G向け予実管理のために利用されます</p>
        <p>💡CONNPATHログイン権限を付与できる企業: <strong>{singleSelectedClientCorporationLabel}</strong></p>;
      </>
    }
    else if (activeClientCorporations.length == 0) {
      return <>
        <p>💡主にCONNPATHの閲覧権限付与やB2G向け予実管理のために利用されます</p>
      </>
    }
    else {
      return <>
        <p>💡主にB2G向け予実管理のために利用されます</p>
        <p>❗提供先を複数選択するとCONNPATHログイン権限を付与できません</p>
      </>
    }
  })();


  // レイアウト
  return <div>
    <SearchableMultiSelect {...newProps} />

    <div>
      <p>💡サービス提供先が見積請求書発行先と異なる場合のみ設定してください</p>
      {message}
    </div>
  </div>
}

export default InquiryClientCorporationSelect;
